const practiceSlider = () => {
  const slider = $('.js-slider-practice');

  slider.slick({
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          adaptiveHeight: true
        }
      }
    ]
  });

  slider.on('afterChange', function (event, slick, currentSlide) {
    $('.slide-item').removeClass('current');
    $('[data-slide-index="' + currentSlide + '"]').addClass('current');
  });

  $('.slide-item').on('click', function (e) {
    e.preventDefault();
    const index = $(this).data('slide-index');
    slider.slick('slickGoTo', index);
  });
};

export default practiceSlider;
